<!--
 * @Author: DY
 * @Date: 2023-09-07 16:00:31
 * @LastEditTime: 2024-09-13 14:02:51
 * @Description:
 * @FilePath: \ShiMo_Mobile\src\views\reportForm\costPage\index.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="costPage">
        <div class="container">
            <nav-bar-box :extr="navData"></nav-bar-box>
            <section>
                <div class="header">
                    <van-radio-group v-model="radio" direction="horizontal" @change="switchingTimeNodes">
                        <van-radio name="month">
                            按月查询
                            <template #icon="props">
                                <i class="iconfont" :class="props.checked ? 'sm-danxuan_': 'sm-danxuan'"></i>
                            </template>
                        </van-radio>
                        <van-radio name="year">
                            按年查询
                            <template #icon="props">
                                <i class="iconfont" :class="props.checked ? 'sm-danxuan_': 'sm-danxuan'"></i>
                            </template>
                        </van-radio>
                    </van-radio-group>
                    <div class="search-conditions iconfont sm-rili" @click="handleShowDatePop('date')">
                        <span>{{ date }}</span>
                    </div>
                </div>
                <div class="main">
                    <div class="chartHeader" v-if="pageType.sphericity">
                        <h4>球形成本构成</h4>
                        <van-button @click="showBreedList = true">
                            <span>{{ breed.dic_name }}</span>
                            <i class="iconfont sm-sanjiao"></i>
                        </van-button>
                    </div>
                    <div class="chart" id="chartBox" :style="{ height: chartHeight}"></div>
                    <div class="tableBox tableBox_fx">
                        <table>
                            <thead>
                                <tr class="total">
                                    <th>{{ navData.title }}</th>
                                    <td colspan="5">
                                        {{ flotationCost }}
                                        <span>{{ unit }}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th style="width: 18%;">
                                        大类
                                    </th>
                                    <th style="width: 18%;">
                                        类别
                                    </th>
                                    <th style="width: 15%;">
                                        单位价格
                                    </th>
                                    <th style="width: 18%;">
                                        单位耗费
                                    </th>
                                    <th style="width: 16%;">
                                        单位金额(元)
                                    </th>
                                    <th>百分比</th>
                                </tr>
                            </thead>
                            <template v-for="(item, index) in tableData">
                                <tbody :key="`tableList_body_${index}`">
                                    <tr>
                                        <td :rowspan="item.val.length + 1">
                                            {{ item.key }}
                                        </td>
                                    </tr>
                                    <template v-for="(k, j) in item.val">
                                        <tr :key="`tableList_list_${j}`" :class="{'selectItem': selectCode == k.item_code}" @click="selectCategory(k)">
                                            <td>{{ k.item_name }}</td>
                                            <td>{{ k.unit_price | displayDecimalControl }}</td>
                                            <td>{{ k.unit_cost | displayDecimalControl }}</td>
                                            <td>{{ k.value | displayDecimalControl }}</td>
                                            <td>{{ k.percentage | displayDecimalControl }}%</td>
                                        </tr>
                                    </template>
                                </tbody>
                            </template>
                        </table>
                    </div>
                    <div class="lineChart" id="lineChart" v-if="showLineChart"></div>
                    <div class="lineChart" id="barChart" v-if="showBarChart"></div>
                </div>
                <van-popup v-model="showDatePop" position="bottom" :style="{ height: '40%' }">
                    <template v-if="radio == 'month'">
                        <van-datetime-picker
                            v-model="dateModel"
                            type="year-month"
                            title="选择年月"
                            @confirm="confirmDate"
                            @cancel="showDatePop=false"
                        ></van-datetime-picker>
                    </template>
                    <template v-else>
                        <van-picker
                            show-toolbar
                            v-model="dateModel"
                            :columns="yearColumns"
                            @confirm="selectYear"
                            :default-index="currIndex"
                            @cancel="showDatePop=false"
                        ></van-picker>
                    </template>
                </van-popup>
                <van-action-sheet
                    v-model="showBreedList"
                    cancel-text="取消"
                    description="选择品种"
                    close-on-click-action
                    :round="false"
                    :actions="breedActions"
                    @select="onSelectBreed"
                ></van-action-sheet>
            </section>
        </div>
    </v-touch>
</template>

<script>
import NP from 'number-precision';
import { pieChart, barChart } from '@/assets/js/charts';
import currencyFun from '@/assets/js/currencyFun/index.js';
import { mixin_showDecimals } from '@/assets/mixin/mixin_showDecimals';

const colors = {
    color_within: [
        ['#773737', '#973838', '#C44747', '#AC6757', '#D27C64', '#F4AE93', '#9B3352', '#CE5478', '#ED6968', '#8D5175', '#BF73A1', '#BF73A1'],
        ['#DF9838', '#CDA74D', '#DC875D'],
        ['#3E89CE', '#384F74', '#466692', '#5D81AD', '#7585A2', '#6D6B7B'],
        ['#8AA84A', '#43522F', '#5E7342', '#789255', '#96B66C', '#8C9B59'],
    ],
    color_outside: ['#ED6967', '#DF9838', '#3E89CE', '#8AA84A'],
};

export default {
    components: {},
    props: {},
    mixins: [mixin_showDecimals],
    data() {
        return {
            navData: {
                title: '',
                leftArrow: true,
            },
            pageType: '',
            radio: 'month',

            showDatePop: false,
            date: '',
            dateModel: '',
            yearColumns: [],
            currenMonth: '',
            currenYear: '',

            currIndex: 0,

            requestUrl: '',
            dataList: [],

            tableData: [],

            chartHeight: '350px',

            flotationCost: 0,

            unit: '（元/吨）',

            showBreedList: false,
            breedActions: [],
            breed: {},
            selectCode: '',
            showLineChart: false,
            showBarChart: false,
            totalList: [],
        };
    },
    async created() {
        this.pageType = this.$route.query;
        for (let i = 1980; i < 2099; i++) {
            this.yearColumns.push(i);
        }
        if (this.pageType.sphericity) {
            this.breedActions = await this.getBreedList();
            this.breedActions.forEach(item => { item.name = item.dic_name;});
            this.getLatestData = await this.getLatestData();
            this.breed = this.breedActions.filter(item => item.dic_code === this.getLatestData.variety_code)[0];
            this.date = this.getLatestData.report_month;
            this.dateModel = new Date(currencyFun.timeFormat(new Date(this.date), 'yyyy-MM'));
        } else {
            this.date = currencyFun.timeFormat(new Date(), 'yyyy-LL');
            this.dateModel = new Date(currencyFun.timeFormat(new Date(), 'yyyy-LL'));
        }
        this.initPage();
    },
    mounted() {},
    methods: {
        async initPage() {
            if (this.pageType.powerSupply) {
                this.navData.title = '供电成本';
                this.unit = '（元/KWH）';
                if (this.radio === 'month') {
                    this.requestUrl = `/electricity_cost/annual_chart_app?report_month=${this.date}`;
                    // 成本柱状图
                    this.requestUrl2 = `/electricity_cost/total_cost_app?report_month=${this.date}`;
                } else {
                    this.requestUrl = `/electricity_cost/annual_chart_app?year=${this.date}`;
                    // 成本柱状图
                    this.requestUrl2 = `/electricity_cost/total_cost_app?year=${this.date}`;
                }
            } else if (this.pageType.water) {
                this.navData.title = '水源成本';
                if (this.radio === 'month') {
                    this.requestUrl = `/water_source_cost/annual_chart_app?report_month=${this.date}`;
                    // 成本柱状图
                    this.requestUrl2 = `/water_source_cost/total_cost_app?report_month=${this.date}`;
                } else {
                    this.requestUrl = `/water_source_cost/annual_chart_app?year=${this.date}`;
                    // 成本柱状图
                    this.requestUrl2 = `/water_source_cost/total_cost_app?year=${this.date}`;
                }
            } else if (this.pageType.mine) {
                this.navData.title = '采矿成本';
                if (this.radio === 'month') {
                    this.requestUrl = `/ore_cost/annual_chart_app?report_month=${this.date}`;
                    // 成本柱状图
                    this.requestUrl2 = `/ore_cost/total_cost_app?report_month=${this.date}`;
                } else {
                    this.requestUrl = `/ore_cost/annual_chart_app?year=${this.date}`;
                    // 成本柱状图
                    this.requestUrl2 = `/ore_cost/total_cost_app?year=${this.date}`;
                }
            } else if (this.pageType.flotation) {
                this.navData.title = '浮选成本';
                this.chartHeight = '600px';
                if (this.radio === 'month') {
                    this.requestUrl = `/flotation_cost/annual_chart_app?report_month=${this.date}`;
                    // 成本柱状图
                    this.requestUrl2 = `/flotation_cost/total_cost_app?report_month=${this.date}`;
                } else {
                    this.requestUrl = `/flotation_cost/annual_chart_app?year=${this.date}`;
                    // 成本柱状图
                    this.requestUrl2 = `/flotation_cost/total_cost_app?year=${this.date}`;
                }
            } else if (this.pageType.sphericity) {
                this.navData.title = '球形成本';
                if (this.radio === 'month') {
                    this.requestUrl = `/sphericity_cost/annual_chart_app?report_month=${this.date}&variety_code=${this.breed.dic_code}`;
                    // 成本柱状图
                    this.requestUrl2 = `/sphericity_cost/total_cost_app?report_month=${this.date}&variety_code=${this.breed.dic_code}`;
                } else {
                    this.requestUrl = `/sphericity_cost/annual_chart_app?year=${this.date}&variety_code=${this.breed.dic_code}`;
                    // 成本柱状图
                    this.requestUrl2 = `/sphericity_cost/total_cost_app?year=${this.date}&variety_code=${this.breed.dic_code}`;
                }
            } else if (this.pageType.crushing) {
                this.navData.title = '碎矿成本';
                if (this.radio === 'month') {
                    this.requestUrl = `/crushed_ore_cost/annual_chart_app?report_month=${this.date}`;
                    // 成本柱状图
                    this.requestUrl2 = `/crushed_ore_cost/total_cost_app?report_month=${this.date}`;
                } else {
                    this.requestUrl = `/crushed_ore_cost/annual_chart_app?year=${this.date}`;
                    // 成本柱状图
                    this.requestUrl2 = `/crushed_ore_cost/total_cost_app?year=${this.date}`;
                }
            }
            this.dataList = await this.getDataList(this.requestUrl);
            this.totalList = await this.getDataList(this.requestUrl2);
            this.showBarChart = true;
            this.$nextTick(async () => {
                this.loadBarChart(this.totalList);
            });
            this.loadData(this.dataList, this.totalList);
        },
        loadData(data, totalList) {
            const list = [];
            const list1 = [];
            const chartList = currencyFun.groupByType(data.detail, 'type_name');
            this.tableData = chartList;
            chartList.forEach((item, index) => {
                item.val.forEach((k, j) => {
                    list.push({
                        name: k.item_name,
                        value: k.value,
                        itemStyle: {
                            color: colors.color_within[index][j] ?? '',
                        },
                    });
                });
            });
            data.total.forEach((item, index) => {
                list1.push({
                    name: item.item_name,
                    value: item.value,
                    itemStyle: {
                        color: colors.color_outside[index],
                    },
                });
            });

            const chartData = {
                chartTitle: `${this.navData.title}构成`,
                titlePosition: ['15', '15'],
                textStyle: {
                    fontSize: 18,
                },
                chartSubtext: '单位： 元',
                series: [{
                    radius: ['40%', '58%'],
                    center: ['50%', '50%'],
                    data: list,
                }, {
                    radius: [0, '31%'],
                    center: ['50%', '50%'],
                    label: {
                        position: 'inner',
                        fontSize: 12,
                        color: '#303030',
                    },
                    labelLine: {
                        show: false,
                    },
                    top: 70,
                    data: list1,
                }],
            };
            if (this.pageType.sphericity) {
                chartData.chartTitle = '';
            }
            this.$nextTick(() => {
                let deductNub = 0;
                const totalNub = data.total.map(item => item.value).reduce((a, b) => Number(a) + Number(b), 0);
                if (data.deductions) {
                    deductNub = data.deductions.map(item => item.value).reduce((a, b) => Number(a) + Number(b), 0);
                    this.tableData.push({
                        key: '扣除项',
                        val: [...data.deductions],
                    });
                }
                this.flotationCost = currencyFun.decimalDistance(NP.minus(totalNub || 0, deductNub || 0));
                pieChart('chartBox', chartData);
            });
        },
        // 时间节点切换
        async switchingTimeNodes(val) {
            if (val === 'month') {
                this.currenYear = JSON.parse(JSON.stringify(this.date));
                this.date = this.currenMonth || currencyFun.timeFormat(new Date(), 'yyyy-MM');
                this.dateModel = new Date(currencyFun.timeFormat(new Date(this.date), 'yyyy-MM'));
            } else {
                this.currenMonth = JSON.parse(JSON.stringify(this.date));
                this.date = this.currenYear || currencyFun.timeFormat(new Date(), 'yyyy');
                this.dateModel = currencyFun.timeFormat(new Date(this.date), 'yyyy');
                this.yearColumns.forEach((item, i) => {
                    if (this.dateModel === item + '') {
                        this.currIndex = i;
                    }
                });
            }
            await this.initPage();
            await this.selectCategory();
        },
        // 打开时间节点选择
        handleShowDatePop() {
            if (this.radio === 'mmonth') {
                this.dateModel = new Date(this.date);
            }
            this.showDatePop = true;
        },
        // 年月选择
        async confirmDate(value) {
            this.date = currencyFun.timeFormat(value, 'yyyy-MM');
            this.showDatePop = false;
            await this.initPage();
            await this.selectCategory();
        },
        // 年选择
        async selectYear(value) {
            this.date = value;
            this.showDatePop = false;
            await this.initPage();
            await this.selectCategory();
        },

        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/home' });
        },

        // 选择品种
        async onSelectBreed(data) {
            this.breed = data;
            await this.initPage();
            await this.selectCategory();
        },

        // 选择类别
        selectCategory(item) {
            this.showBarChart = false;
            this.showLineChart = true;
            this.$nextTick(async () => {
                if (item) {
                    this.selectCode = item.item_code;
                }
                let url = '';
                if (this.pageType.powerSupply) { // 供电
                    if (!this.selectCode) {return false;}
                    url = `/electricity_cost/unit_price_cost_app?code=${this.selectCode}`;
                }
                if (this.pageType.water) { // 水源
                    if (!this.selectCode) {return false;}
                    url = `/water_source_cost/unit_price_cost_app?code=${this.selectCode}`;
                }
                if (this.pageType.mine) { // 采矿
                    if (!this.selectCode) {return false;}
                    url = `/ore_cost/unit_price_cost_app?code=${this.selectCode}`;
                }
                if (this.pageType.flotation) { // 浮选
                    if (!this.selectCode) {return false;}
                    url = `/flotation_cost/unit_price_cost_app?code=${this.selectCode}`;
                }
                if (this.pageType.crushing) { // 碎矿
                    if (!this.selectCode) {return false;}
                    url = `/crushed_ore_cost/unit_price_cost_app?code=${this.selectCode}`;
                }
                if (this.pageType.sphericity) { // 球形
                    if (!this.selectCode) {return false;}
                    url = `/sphericity_cost/unit_price_cost_app?variety_code=${this.breed.dic_code}&code=${this.selectCode}`;
                }
                if (this.radio === 'month') {
                    url = `${url}&report_month=${this.date}`;
                } else {
                    url = `${url}&year=${this.date}`;
                }
                const res = await this.getDataList(url);
                this.loadlineBarChart(res);
            });
        },

        // 成本柱状图
        loadBarChart(res) {
            const chartData = {
                xdata: [],
                legendData: ['成本'],
                grid: {
                    top: 60,
                    left: 50,
                    right: 30,
                    bottom: 50,
                },
                yAxisName: ['(成本)'],
                ydata: [
                    {
                        name: '成本',
                        type: 'bar',
                        color: ['#547796', '#547796'],
                        data: [],
                        position: 'left',
                        yAxisIndex: 0,
                    },
                ],
            };
            res.forEach(item => {
                chartData.xdata.push(item.report_month);
                chartData.ydata[0].data.push(item.total_cost);
            });
            if (chartData.xdata.length > 5) {
                chartData.grid.bottom = 50;
            }
            barChart('barChart', chartData);
        },

        loadlineBarChart(res) {
            const chartData = {
                xdata: [],
                legendData: ['单位金额', '单位价格', '单位耗费'],
                selectedMode: 'single',
                selected: {
                    单位金额: false,
                    单位价格: false,
                    单位耗费: false,
                },
                grid: {
                    top: 60,
                    left: 50,
                    right: 30,
                    bottom: 50,
                },
                yAxisName: [],
                ydata: [
                    {
                        name: '单位金额',
                        type: 'bar',
                        color: ['#EDA94D', '#EDA94D'],
                        data: [],
                        yAxisIndex: 0,
                    },
                    {
                        name: '单位价格',
                        type: 'bar',
                        color: ['#547796', '#547796'],
                        data: [],
                        yAxisIndex: 0,
                    }, {
                        name: '单位耗费',
                        type: 'bar',
                        color: ['#ED6967', '#ED6967'],
                        data: [],
                        yAxisIndex: 0,
                    },
                ],
            };
            res.forEach(item => {
                chartData.xdata.push(item.report_month);
                chartData.ydata[0].data.push(item.unit_money);
                chartData.ydata[1].data.push(item.unit_price);
                chartData.ydata[2].data.push(item.unit_cost);
            });
            if (chartData.xdata.length > 5) {
                chartData.grid.bottom = 50;
            }
            barChart('lineChart', chartData);
        },

        // 获取品种数据
        getBreedList() {
            return this.$axios.$get('/interfaceApi/report/zjc_dictionary/get_sub_list/SMLX-QXSM', { defEx: true });
        },

        // 获取最新数据的月份与品种
        getLatestData() {
            return this.$axios.$get('/interfaceApi/report/sphericity_cost/get_latest_data', { defEx: true });
        },

        // 获取数据
        getDataList(requestUrl) {
            return this.$axios.$get(`/interfaceApi/report${requestUrl}`, { defEx: true });
        },
    },
};
</script>
<style lang="stylus" scoped>
.container
    height 100%
    section
        height calc(100% - 66rpx)
        .header
            height 52rpx
            background #F8F8F8
            border-bottom 1px solid #F0F0F0
            padding 0 14rpx
            display flex
            justify-content: space-between
            align-items: center
            >>>.van-radio-group
                .van-radio
                    display flex
                    align-items: center
                    margin-right: 20rpx
                    .van-radio__icon
                        width 14rpx
                        height 14rpx
                        display: flex;
                        align-items: center;
                        .iconfont
                            color #999999
                        &.van-radio__icon--checked
                            .iconfont
                                color #EB0003
                            &+.van-radio__label
                                color #EB0003
                    .van-radio__label
                        font-size 14rpx
                        color #999999
            .search-conditions
                width 120rpx
                height 32rpx
                line-height: 30rpx
                background: #F0F0F0;
                border-radius: 4px;
                border: 1px solid #D7D7D7;
                font-size 14rpx
                color #343434
                text-align: center
                position: relative
                padding 0
                padding-left: 20rpx
                &:before
                    position: absolute
                    top 0
                    left 10rpx
        .main
            height calc(100% - 52rpx)
            overflow-y: scroll
            .chartHeader
                padding 15rpx 15rpx 0 15rpx
                display flex
                justify-content space-between
                h4
                    font-size 18rpx
                    line-height: 30rpx
                    color #000000
                    font-weight bold
                .van-button
                    height 30rpx
                    background: #fbebec
                    border 1px solid #f5c9ca
                    color #ee3344
                    border-radius 4rpx
                    .van-button__text
                        width 100%
                        display flex
                        justify-content space-between
                        align-items center
                    i
                        font-size 7rpx
                        margin-left 10rpx
            .chart
                height: 350rpx
            .tableBox
                padding 14rpx
                &.tableBox_fx
                    overflow auto
                    table
                        width 150%
                        th,td
                            width 10%
                table
                    width 100%
                    border-collapse: collapse
                    th,td
                        height: 32rpx
                        color #343434
                        font-size 14rpx
                        border 1px solid #E4E4E4
                        width 33.33%
                        text-align: center
                        padding 0 10rpx
                    th
                        background: #FBEEEE
                        border-color #EAD9D9
                    td
                        text-align: right
                        &:first-child
                            text-align: center
                    tbody
                        tr
                            &:nth-child(even)
                                td
                                    background: #F9FAFD
                            &.selectItem
                                td
                                    color #FFFFFF
                                    background: #EDA94D
                                    border: 1px solid #E4E4E4
                                    &:first-child
                                        color #783F14
                                        background #E5D3A8
                    .total
                        td
                            text-align left
            .lineChart
                margin 20rpx 0
                height 248rpx
        .van-action-sheet
            max-height 50%
</style>
